// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__3D284","row":"ProcedureTreatmentSummary_row__36HSR"};